import axios from "axios";
import { ODOO_SESSION_DEFAULTS } from "@/config/odooSessionDefaults.js";

class MainService {
    static session = null;
    static apiUrl = import.meta.env.MODE === 'development' ? import.meta.env.VITE_DEV_URL : import.meta.env.VITE_API_URL;
    static sessionId = null;
    /** Dedupe concurrent first requests (e.g. Slider before App onMounted finishes handleSession). */
    static _sessionInitPromise = null;
    constructor() {


    }

    /**
     * Ensures axios instance + Odoo authenticate ran before normal API calls.
     * `getSession` assigns `session` before calling `post(authenticate)`, so auth never recurses here.
     */
    static async ensureSessionForApi() {
        if (MainService.session) {
            return;
        }
        if (!MainService._sessionInitPromise) {
            MainService._sessionInitPromise = MainService.getSession().finally(() => {
                MainService._sessionInitPromise = null;
            });
        }
        await MainService._sessionInitPromise;
    }

    static async handleSession() {
        await MainService.getSession();
    }

    static createUrl(endpoint = "") {
        return `${MainService.apiUrl}/${endpoint}`;
    }

    static createPayload(params) {
        return {
            jsonrpc: "2.0",
            method: "call",
            params: params,
            'id': null
        };
    }

    static async getSession() {
        const { db, login: username, password } = ODOO_SESSION_DEFAULTS;

        const authPayload = {
            jsonrpc: '2.0',
            method: 'call',
            params: {
                db: db,
                login: username,
                password: password,
            },
            id: null
        };

        try {
            // Create an axios instance with withCredentials to handle cookies
            MainService.session = axios.create({
                baseURL: MainService.apiUrl,
                withCredentials: true, // Important for cookie handling
                timeout: 120000, // avoid indefinite hang (catalog / version never resolve → spinner forever)
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const response = await MainService.post(`web/session/authenticate`, authPayload);
            // Save session_id if present
            if (response && response.data && response.data.result && response.data.result.session_id) {

                MainService.sessionId = response.data.result.session_id;
            }
        } catch (error) {
            console.error('Error starting session:', error);
            throw error;
        }
    }

    static get(url, headers, body = {}) {
        return new Promise(async (res, rej) => {
            try {
                await MainService.ensureSessionForApi();

                const config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: MainService.createUrl(url),
                    headers: headers,
                    params: body
                };

                const response = await MainService.session.request(config);
                if (response.data.error) {
                    console.error('Request failed:', response.data.error);
                    return res({
                        success: false,
                        error: response.data.error,
                        data: null,
                    });
                }

                return res({
                    success: true,
                    data: response.data,
                    error: null
                });
            } catch (error) {
                console.error('Error during Request:', error);
                rej({
                    success: false,
                    error: error.message,
                    data: null,

                });
            }

        });

    }

    static post(url, body = {}, headers = {}) {

        return new Promise(async (res, rej) => {
            try {
                await MainService.ensureSessionForApi();

                const config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: MainService.createUrl(url),
                    headers: headers,
                    data: body
                };

                const response = await MainService.session.request(config);

                if (response.data.error) {
                    console.error('Request failed:', response.data.error);
                    return res({
                        success: false,
                        error: response.data.error,
                        data: null,
                    });
                }

                return res({
                    success: true,
                    data: response.data,
                    error: null
                });
            } catch (error) {
                console.error('Error during Request:', error);
                rej({
                    success: false,
                    error: error.message,
                    data: null,

                });
            }

        });

    }

    static async getSlider(version = "2.8", platform = "ios") {
        return await MainService.post('sales/slider', {
            "version": version,
            "platform": platform

        });
    }
}





export default MainService;